import { useTheme } from '@/providers/theme-provider';
import { Select } from '@/components/base/select/select';
import { Settings01 } from '@untitledui/icons';
import { useTranslation } from 'react-i18next';

export const ThemeSwitcher = () => {
    const { theme, setTheme } = useTheme();
    const { t } = useTranslation('common');

    const themes = [
        { id: 'light', label: t('themeLight') },
        { id: 'dark', label: t('themeDark') },
        { id: 'system', label: t('themeSystem') },
    ];

    return (
        <div className="space-y-2">
            <label className="text-sm font-medium text-primary">
                {t('theme')}
            </label>
            <Select
                selectedKey={theme}
                onSelectionChange={(key) => {
                    if (key && typeof key === 'string') {
                        setTheme(key as 'light' | 'dark' | 'system');
                    }
                }}
                placeholderIcon={Settings01}
                size="md"
            >
                {themes.map((themeOption) => (
                    <Select.Item key={themeOption.id} id={themeOption.id}>
                        {themeOption.label}
                    </Select.Item>
                ))}
            </Select>
        </div>
    );
};


